import { Input as CoreInput } from '@eleo-rh/core-ui'
import type { InputRef } from 'antd'
import { useI18n } from 'context/I18nProvider'
import { type ChangeEvent, type ComponentProps, type Ref, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

type BaseInputProps = ComponentProps<typeof CoreInput.Search>

type SearchInputProps = Omit<BaseInputProps, 'onChange' | 'onSearch'> & {
  onChange: (txt: string) => void
  minCharSearch?: number
  ref?: Ref<InputRef>
}

const SearchInput = ({ ref, ...props }: SearchInputProps) => {
  const { onChange, value, defaultValue, debounceTime = 300, minCharSearch = 0, ...rest } = props
  const { i18n } = useI18n()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const search = searchParams.get('q')
  const resolvedDefaultValue = defaultValue ?? search ?? ''
  const resolvedValue = value ?? resolvedDefaultValue
  const [inputValue, setInputValue] = useState(resolvedValue)

  useEffect(() => {
    setInputValue(resolvedValue)
  }, [resolvedValue])

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value)

    if (debounceTime === 0) onChange(event.target.value)
  }

  return (
    <CoreInput.Search
      ref={ref}
      value={inputValue}
      onChange={handleChange}
      onSearch={onChange}
      debounceTime={debounceTime}
      minCharSearch={minCharSearch}
      placeholder={i18n('label.searchplaceholder')}
      allowClear
      size="medium"
      {...rest}
    />
  )
}
export default SearchInput
